import React from 'react';

const DeleteAccount = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Delete Your Account</h1>
      <p style={styles.text}>To delete your account, please follow these steps:</p>
      <ol style={styles.list}>
        <li style={styles.listItem}>Open the app and log in to your account. If you want you can reset your password to login.</li>
        <li style={styles.listItem}>Navigate to the About page.</li>
        <li style={styles.listItem}>Scroll down to the Delete Account button.</li>
        <li style={styles.listItem}>Confirm your choice to delete your account.</li>
      </ol>
      <p style={styles.text}>If you encounter any issues, please contact our support team at <a href="mailto:order@dialine.ch">order@dialine.ch</a>.</p>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    margin: '0 auto',
    padding: '20px',
    maxWidth: '600px',
    textAlign: 'center',
  },
  header: {
    color: '#333',
  },
  text: {
    fontSize: '16px',
    color: '#555',
  },
  list: {
    textAlign: 'left',
    margin: '20px 0',
  },
  listItem: {
    marginBottom: '10px',
  },
};

export default DeleteAccount;
